export default {
    //意大利语
    DiagnosticReport:'Relazione diagnostica',
    troubleCode:'Codice dei guasti',
    time:'tempo',
    // 语言
    lang:{
        cn:'cinese',
        de:'Tedesco',
        en:'Inglese',
        es:'Spagnolo',
        fr:'Francese',
        it:'Italiano',
        ja:'Giapponese',
        ko:'coreano',
        pt:'portoghese'
    }
}